import { Button, customStyled } from '@mafc/trolly';

export const RoundCornerButton = customStyled(Button)(({ theme: { fontWeights } }) => ({
  width: '100%',
  height: '48px',
  fontWeight: fontWeights[8],
  borderRadius: '12px',
  textTransform: 'none',
}));
